import UsuarioPerfilPage from './pages/UsuarioPerfilPage.vue'
import UsuarioPerfilAssociacaoPage from './pages/UsuarioPerfilAssociacaoPage'

const routes = [
  {
    path: 'usuarios-perfis',
    name: 'usuarios-perfis',
    component: UsuarioPerfilPage
  },
  {
    path: 'usuarios-perfis/:usuario',
    name: 'usuarios-perfis-associacao',
    component: UsuarioPerfilAssociacaoPage
  }
];

export default routes;